import { render, staticRenderFns } from "./UploadComp.vue?vue&type=template&id=1bb166b0&scoped=true&"
import script from "./UploadComp.vue?vue&type=script&lang=js&"
export * from "./UploadComp.vue?vue&type=script&lang=js&"
import style0 from "./UploadComp.vue?vue&type=style&index=0&id=1bb166b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb166b0",
  null
  
)

export default component.exports